<div dir="ltr">
  <h1 mat-dialog-title>{{data.car.Manufacturer}} {{data.car.Model}}</h1>
  <div mat-dialog-content>
    <p>{{data.car.description}}</p>
    <p-carousel [value]="data.car.Files">
      <ng-template let-file pTemplate="item">
        <div class="carousel-item">
          <img [src]="file.url" alt="Slide" class="carousel-image">
        </div>
      </ng-template>
    </p-carousel>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">{{ 'COMMON.CLOSE' | translate }}</button>
  </div>
</div>


